<template>
    <div class="swiper26">
        <img class="bg" src="@/assets/2026/mobile/bg.jpg" alt="">
        <div class="title">
          <img src="@/assets/2026/mobile/font.png" alt="">
        </div>
        <swiper class="swiper-container vertical-swiper" :options="swiperOption" ref="diySwiper" v-if="swiperList2.length > 0">
            <swiper-slide v-for="(item, index) in swiperList2" :key="index">
            <img :src="item.img" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
import Vue from 'vue'
import VueAwesomeSwiper, { Swiper, SwiperSlide  } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import banner1 from '@/assets/2026/mobile/1.jpg'
import banner2 from '@/assets/2026/mobile/2.jpg'
import banner3 from '@/assets/2026/mobile/3.jpg'
import banner4 from '@/assets/2026/mobile/4.jpg'
import banner5 from '@/assets/2026/mobile/5.jpg'
import banner6 from '@/assets/2026/mobile/6.jpg'

// import { getStarModels } from '@/request/api';

Vue.use(VueAwesomeSwiper)

export default {
  name: 'diySwiper',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        speed: 600,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 15,
        effect: 'slide',
        grabCursor: true,
        keyboard: {
          enabled: true,
        }
      },
      swiperList2: [
        {
          img: banner1,
          text: '',
          link: '',
        }, {
          img: banner2,
          text: 'CiCi',
          link: '',
        },
        {
          img: banner3,
          text: '',
          link: '',
        },
        {
          img: banner4,
          text: '',
          link: '',
        },
        {
          img: banner5,
          text: '',
          link: '',
        },
        {
          img: banner6,
          text: '',
          link: '',
        },
      ],
    }
  },
  setup() {
    return {};
  },
  methods: {
    // handleExplore(item){
    //   this.$router.push(item.data.url)
    //   window._hmt.push(['_trackEvent', '官网首页', '车型探索', item.title]);
    // }
  },
  mounted() {
    // getStarModels().then(res => {
    //   // console.log(res)
    //   this.swiperList = res.data;
    // })
  },
};
</script>
<style scoped lang="scss">
    .vertical-swiper {
      height: auto;
      width: 100%;
      margin: 0;
      padding: 22vh 0 20vh;
      /* background: #000; */
      position: relative;
      z-index: 10;
    }

    /* 分页器样式 */
    .vertical-swiper :deep(.swiper-pagination) {
      position: absolute;
      bottom: 16vh;
      left: 50%;
      transform: translateX(-50%);
      width: auto;
      z-index: 111;
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .vertical-swiper :deep(.swiper-pagination-bullet) {
      width: 60px;
      height: 4px;
      background-color: #e2e2e2;
      border-radius: 1.5px;
      opacity: 1;
      margin: 0 !important;
      transition: all 0.3s ease;
    }

    .vertical-swiper :deep(.swiper-pagination-bullet-active) {
      background-color: #ffd200;
      width: 60px;
    }

    .vertical-swiper .swiper-wrapper {
      height: 100%;
      align-items: center;
    }

    .vertical-swiper .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      box-sizing: border-box;
      width: 25%;
      opacity: 1;
    }

    .vertical-swiper .swiper-slide-active {
      opacity: 1;
      width: 50%;
    }

    .vertical-swiper .swiper-slide img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      min-height: 100%;
      min-width: 100%;
      border-radius: 10px;
    }

    .vertical-swiper .swiper-slide-active img {}

    .vertical-swiper .swiper-slide {}

    .swiper26 {
      position: relative;
      width: 100%;
    }

    .swiper26 .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      z-index: 0;
    }

    .swiper26 .title {
      position: absolute;
      top: 6vh;
      left: 15%;
      width: 70%;
      text-align: center;
      z-index: 9;
    }

    .swiper26 .title img {
      max-width: 100%;
      height: auto;
    }

    
</style>
